import React from 'react'

import { theme } from '@components/Theme'

import { Svg } from './Svg'

export interface SelectMealKitsCompletedProps {
  color?: string
  hoverColor?: string
  className?: string
  size?: string | number
}

export function SelectMealKitsCompleted({ color = theme.colors.greys.mineshaft, hoverColor, className, size = '100%' }: SelectMealKitsCompletedProps): JSX.Element {
  return (
    <Svg
      $strokeColor={color}
      $strokeHoverColor={hoverColor}
      $fillColor={color}
      $fillHoverColor={hoverColor}
      className={className}
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M15.32 12.6799C14.992 12.2559 14.776 11.8079 14.792 11.2959C14.776 10.8399 14.952 10.4319 15.24 10.0479C15.768 9.3439 15.912 8.6399 15.328 7.9119C15.184 7.7359 15.216 7.5519 15.464 7.4479C15.72 7.3439 15.92 7.4079 16.072 7.6079C16.664 8.3839 16.712 9.1839 16.224 10.0079C16.136 10.1519 16.032 10.2879 15.928 10.4239C15.464 11.0159 15.456 11.6079 15.896 12.1999C15.936 12.2479 15.968 12.3039 16.008 12.3599C16.152 12.5599 16.104 12.7359 15.856 12.8479C15.616 12.9519 15.448 12.8479 15.32 12.6879V12.6799ZM18.16 12.8399C18.408 12.7279 18.456 12.5519 18.312 12.3519C18.272 12.3039 18.24 12.2479 18.2 12.1919C17.752 11.5919 17.76 10.9999 18.232 10.4159C18.336 10.2799 18.44 10.1439 18.528 9.9999C19.016 9.1839 18.96 8.3839 18.376 7.5999C18.224 7.3999 18.024 7.3359 17.768 7.4399C17.52 7.5439 17.488 7.7279 17.632 7.9039C18.216 8.6319 18.072 9.3359 17.544 10.0399C17.256 10.4239 17.088 10.8399 17.096 11.2879C17.08 11.7919 17.296 12.2479 17.624 12.6719C17.752 12.8319 17.92 12.9359 18.16 12.8319V12.8399ZM20.472 12.8399C20.72 12.7279 20.768 12.5519 20.624 12.3519C20.584 12.3039 20.552 12.2479 20.512 12.1919C20.064 11.5919 20.072 10.9999 20.544 10.4159C20.648 10.2799 20.752 10.1439 20.84 9.9999C21.328 9.1839 21.272 8.3839 20.688 7.5999C20.536 7.3999 20.336 7.3359 20.08 7.4399C19.832 7.5439 19.8 7.7279 19.944 7.9039C20.528 8.6319 20.384 9.3359 19.856 10.0399C19.568 10.4239 19.4 10.8399 19.408 11.2879C19.392 11.7919 19.608 12.2479 19.936 12.6719C20.064 12.8319 20.232 12.9359 20.472 12.8319V12.8399Z" fill="white"/>
      <path d="M5.67969 14.2959V17.0719C5.67969 21.7119 8.91969 25.6399 13.4157 27.0479V28.6079H22.5597V27.0559C27.0717 25.6559 30.3197 21.7199 30.3197 17.0719V14.2959H5.67969Z" fill="white"/>
      <path d="M6.40039 10.4004L9.60039 13.6004" stroke="white" strokeLinecap="round"/>
    </Svg>
  )
}
